import React from 'react'
import styled, { css } from 'styled-components'

export const Container = styled.div<{ $align: string; $flex?: number }>`
    display: flex;
    justify-content: ${({ $align }) => $align};
    align-items: center;
    ${({ $flex }) =>
        $flex &&
        css`
            flex: ${$flex};
        `}
`

export const Row: React.FC<{
    align?: string
    flex?: number
    style?: React.CSSProperties
    className?: string
}> = ({ children, align = 'flex-start', flex, style, className }) => {
    return (
        <Container $align={align} $flex={flex} style={style} className={className}>
            {children}
        </Container>
    )
}

export const FullWidthRow = styled.div`
    width: 100%;
    display: flex;
    flex-display: row;
    justify-content: center;
`
